{
  "version": 1,
  "asset_id": "9891c47d-d38d-45f3-ba17-52d809d808e1",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/9891c47d-d38d-45f3-ba17-52d809d808e1/acciona.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/9891c47d-d38d-45f3-ba17-52d809d808e1/acciona.png",
  "original_filename": "acciona.png",
  "size": 10221,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:50:58Z"
}
